module.exports = __webpack_public_path__ + "img/opening_sensor.e4d2c016.svg";